import { Component, OnInit } from '@angular/core';
import { Router} from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { faFileContract} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-abhihomes',
  templateUrl: './abhihomes.component.html',
  styleUrls: ['./abhihomes.component.scss']
})
export class AbhiHomesComponent implements OnInit {

    public latitude: Number;
    public longitude: Number;
    public zoom: Number;
    public faFileAlt = faFileContract;

  constructor(private router: Router, private http : HttpClient) { }

  ngOnInit(): void {
    window.scroll(0,0);
    this.latitude = 13.2286811;
    this.longitude = 77.7096878;
    this.zoom = 12;
  }

 
}
